import { Box, Typography } from '@mui/material';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';

import { useDepartment } from '../../../hooks/useDepartment';
import WorkerCategoryTag from '../../contracts/WorkerCategoryTag';
import { ExpandableTypography } from '../../ExpandableTypography';
import UserAvatar from '../../UserAvatar';

export const workerNameAndPictureColumn = (): GridColDef => ({
  field: 'name',
  headerName: 'Nome',
  flex: 1,
  sortable: true,
  valueGetter: (params: GridValueGetterParams) => {
    return {
      name: params?.row?.name,
      pictureUrl: params?.row?.profilePictureUrl,
    };
  },
  renderCell: ({ value }) => {
    const { name, pictureUrl } = value;
    return !name ? (
      '-'
    ) : (
      <UserAvatar
        name={name}
        pictureUrl={pictureUrl}
        expandNameOnHover={true}
        sx={{
          '--UserAvatar-name-max-width': '12.5em',
        }}
        avatarProps={{
          ml: 0,
        }}
      />
    );
  },
});

export const workerNameColumn = ({
  field = 'workerData.name',
  headerName = 'Pessoa',
  valueGetter = (params: GridValueGetterParams) => {
    return params.row.workerData.name;
  },
}: {
  field?: string;
  headerName?: string;
  valueGetter?: (params: GridValueGetterParams) => string;
} = {}): GridColDef => ({
  field,
  sortable: true,
  width: 150,
  headerName,
  valueGetter,
  renderCell: ({ value }) => {
    return <ExpandableTypography>{value || '-'}</ExpandableTypography>;
  },
});

export const cargoColumn = ({
  field = 'title',
  headerName = 'Cargo/Posição',
  valueGetter = (params: GridValueGetterParams) => {
    return params.row.jobTitleName || params.row.titleName;
  },
}: {
  field?: string;
  headerName?: string;
  valueGetter?: (params: GridValueGetterParams) => string;
} = {}): GridColDef => ({
  field,
  headerName,
  flex: 1,
  valueGetter,
  renderCell: ({ value }) => {
    return (
      <ExpandableTypography expandTextOnHover={true}>
        {value ?? '-'}
      </ExpandableTypography>
    );
  },
});

const NameDepartment = ({
  name,
  departmentId,
}: {
  name: string;
  departmentId: string;
}) => {
  const department = useDepartment(departmentId);

  return (
    <Box display="flex" flexDirection="column">
      <Typography noWrap variant="body2">
        {name}
      </Typography>
      <Typography noWrap variant="caption">
        {department?.name ?? '--'}
      </Typography>
    </Box>
  );
};

export const nameAndDepartmentColumn = (): GridColDef => {
  return {
    sortable: false,
    width: 150,
    field: 'vacationNameDepartment',
    headerName: 'Pessoa',
    valueGetter: (params: GridValueGetterParams) => {
      return params.row;
    },
    renderCell: ({ value }) => {
      return (
        <NameDepartment
          name={value.workerData.name}
          departmentId={value.workerData.departmentId}
        />
      );
    },
  };
};

export const workerCategoryColumn = (): GridColDef => ({
  field: 'workerCategory',
  sortable: false,
  headerName: 'Modalidade',
  valueGetter: (params: GridValueGetterParams) => {
    return { workerCategory: params.row.workerCategory };
  },
  renderCell: ({ value }) => {
    const { workerCategory } = value;
    return <WorkerCategoryTag workerCategory={workerCategory} />;
  },
});
